"use client";
import { useEffect } from "react";
import { Props } from "../util";
import { sendPv } from "@/tracks/25157";

export default function Effect({ searchParams }: Props) {
  useEffect(() => {
    sendPv.Search_ProductList();
  }, []);
  useEffect(() => {
    (window as any)?.JDIheader?.initSearchKeyword();
  }, [searchParams.k]);
  return null;
}
